/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_Pick_DateInputs */

const es_settings_files_filters_pick_date = /** @type {(inputs: Settings_Files_Filters_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elegí una fecha…`)
};

const en_settings_files_filters_pick_date = /** @type {(inputs: Settings_Files_Filters_Pick_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a date…`)
};

/**
* | output |
* | --- |
* | "Pick a date…" |
*
* @param {Settings_Files_Filters_Pick_DateInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_pick_date = /** @type {((inputs?: Settings_Files_Filters_Pick_DateInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_Pick_DateInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_pick_date(inputs)
	return en_settings_files_filters_pick_date(inputs)
});
export { settings_files_filters_pick_date as "settings.files.filters.pick_date" }